import { render, staticRenderFns } from "./FlashReport.vue?vue&type=template&id=42b5fc26&"
import script from "./FlashReport.vue?vue&type=script&lang=js&"
export * from "./FlashReport.vue?vue&type=script&lang=js&"
import style0 from "./FlashReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QTabs,QTab,QBtnToggle,QCard,QSpinner,QRouteTab,QTabPanels,QTabPanel,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QTabs,QTab,QBtnToggle,QCard,QSpinner,QRouteTab,QTabPanels,QTabPanel,QIcon})
